module.exports = __webpack_public_path__ + "static/mitch-profile-pic.d5ea4760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/mitch-profile-pic.jpg
// module id = 317
// module chunks = 35783957827783 107818501498521